import { motion } from 'framer-motion';
import { Users, Globe, Zap } from 'lucide-react';
import Section from '../components/Section';
import PageHero from '../components/PageHero';
import { SF_UI } from '../components/ui/tokens';

const CommunityHubPage = () => {
  return (
    <>
      <PageHero
        eyebrow="Community"
        title="Welcome to the SportsFuture Community Hub"
        subtitle="Connect, collaborate, and grow with athletes and supporters worldwide."
        icon={<Users size={28} className="text-primary-100" />}
      />
      <Section bgColor={SF_UI.sectionBand} className="pt-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto"
        >
          <div className={`${SF_UI.surfaceCard} ${SF_UI.surfaceCardPad} mb-10 space-y-6 text-lg text-gray-700`}>
            <p>
              The SportsFuture Community Hub is your gateway to a thriving ecosystem of athletes,
              supporters, sports officers, and innovators building the future of sports funding
              together.
            </p>
            <p>
              Share stories, discover opportunities, and take part in governance conversations that
              shape how support reaches athletes around the world.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white p-6 rounded-2xl shadow-md sf-surface-card sf-ui-system text-center border border-primary-200"
            >
              <Globe className="mx-auto mb-3 text-primary" size={32} />
              <div className="text-3xl font-bold text-primary mb-2">Global</div>
              <div className="text-gray-600">Community reach</div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.05 }}
              className="bg-white p-6 rounded-2xl shadow-md sf-surface-card sf-ui-system text-center border border-secondary-200"
            >
              <Zap className="mx-auto mb-3 text-secondary" size={32} />
              <div className="text-3xl font-bold text-secondary mb-2">Live</div>
              <div className="text-gray-600">Engagement</div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="bg-white p-6 rounded-2xl shadow-md sf-surface-card sf-ui-system text-center border border-primary-200"
            >
              <div className="text-3xl font-bold text-primary mb-2">Web3.0</div>
              <div className="text-gray-600">Revolution</div>
            </motion.div>
          </div>
        </motion.div>
      </Section>
    </>
  );
};

export default CommunityHubPage;
